import axios from 'axios';
import moment from 'moment';
import * as config from '../config';

export const SETISLOADINGDEVICES = 'devices/SETISLOADINGDEVICES';
export const SETDEVICES = 'devices/SETDEVICES';

export const getDevices = (onSuccess = () => {}, onError = () => {}) => {
  return (dispatch, getState) => {

    dispatch({type: SETISLOADINGDEVICES, isLoadingDevices: true});

    axios(`${config.endpoints.base_url}v4/devices`).then((resp) => {
      dispatch({type: SETISLOADINGDEVICES, isLoadingDevices: false});
      dispatch({type: SETDEVICES, devices: resp.data.data.rows});
      return onSuccess(resp.data);
    }).catch((err) => {
      onError(err);
    })
  }
}

export const getDeviceByID = (device_id) => {
  return (dispatch, getState) => {
    if(getState().devices.devices) {
      const device = getState().devices.devices.find((device) => {
        return device.id === parseInt(device_id, 10);
      });
      if(device) {
        return device;
      }
    }
    return null;
  };
}

export const SETISEDITINGDEVICE = 'sites/SETISEDITINGDEVICE';

export const editDevice = ({ id, device }, onSuccess = () => {}, onError = () => {}) => {
  return (dispatch, getState) => {

    const retransformedDevice = retransformDevice(device);
    dispatch({type: SETISEDITINGDEVICE, isEditingDevice: true});
    axios.put(
      `${config.endpoints.base_url}v2/devices/${id}`,
      retransformedDevice,
    ).then((resp) => {
      dispatch({type: SETISEDITINGDEVICE, isEditingDevice: false});
      return onSuccess();
    }).catch((err) => {
      dispatch({type: SETISEDITINGDEVICE, isEditingDevice: false});
      onError(err);
    })

  }
}

const retransformDevice = (device) => {
  if(device.feeders.length > 0) {
    device.feeders = device.feeders.map(row => {
      return {
        id: row.id,
        location_id: row.location_id
      }
    })
  }
  return {
    name: device.name,
    site_id: device.site_id,
    location_id: device.location_id,
    description: device.description,
    // zone_id: device.zone_id,
    type_id: device.type_id,
    tags: device.tags,
    feeders: device.feeders
    // device_attributes: [
    //   {attribute: 'description', value: device.description},
    //   {attribute: "os", value: "Windows 10"},
    // 	{attribute: "processor", value: "Intel&reg; Core&trade; i7-97000K"},
    // 	{attribute: "viana_version", value: "4.62.7"},
    // 	{attribute: "serial_number", value: "48eec7f3-4353-4759-93ee-88aa7808455c"}
    // ]
  }
}

export const STATUS = {
  ONLINE: { name: 'Online', from: 0, to: 1 },
  WARNING: { name: 'Warning', from: 1, to: 6 },
  OFFLINE: { name: 'Offline', from: 6, to: Number.POSITIVE_INFINITY },
  INACTIVE: { name: 'Inactive', from: -1 },
}

export const getDeviceStatus = (updatedAt) => {
  let status = STATUS.INACTIVE;
  let duration = null;

  if(updatedAt) {
    duration = moment.duration(moment().diff(updatedAt));
    const hours = duration.asHours();

    if (hours >= STATUS.ONLINE.from && hours < STATUS.ONLINE.to) {
      status = STATUS.ONLINE;
    } else if (hours >= STATUS.WARNING.from && hours < STATUS.WARNING.to) {
      status = STATUS.WARNING;
    } else if (hours >= STATUS.OFFLINE.from && hours < STATUS.OFFLINE.to) {
      status = STATUS.OFFLINE;
    }
  }

  return status;

}

export const CONNECTIVITYSTATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const getDevicesBySiteID = (site_id) => {
  return (dispatch, getState) => {
    if(getState().devices.devices) {
      const devices = getState().devices.devices.filter((device) => {
        return device.site_id === parseInt(site_id, 10);
      });
      if(devices) {
        return devices;
      }
    }
    return null;
  };
}

export const getDevicesByLocationID = (location_id) => {
  return (dispatch, getState) => {
    if(getState().devices.devices) {
      const devices = getState().devices.devices.filter((device) => {
        return device.location_id === parseInt(location_id, 10);
      });
      if(devices) {
        return devices;
      }
    }
    return null;
  };
}

export const deviceActivation = (id,  onSuccess = () => {}, onError = () => {}) => {
  return (dispatch, getState) => {
    dispatch({type: SETISEDITINGDEVICE, isEditingDevice: true});
    axios.post(
      `${config.endpoints.base_url}v1/devices/${id}/activation`
    ).then((resp) => {
      dispatch({type: SETISEDITINGDEVICE, isEditingDevice: false});
      return onSuccess(resp);
    }).catch((err) => {
      return onError(err);
    })
  }
}

export const checkPairingCode = (pairingCode,  onSuccess = () => {}, onError = () => {}) => {
  return (dispatch, getState) => {
    axios.get(`${config.endpoints.base_url}v4/devices/${pairingCode}/status`)
    .then((resp) => {
      return onSuccess(resp);
    }).catch((err) => {
      return onError(err);
    })
  }
}

export const pairDevice = (pairingCode) => {
  return (dispatch, getState) => {
    return axios.post(`${config.endpoints.base_url}v4/devices`, { "pairing_code": pairingCode });
  }
}

export const previewUnregisterDevice = (deviceId) => {
  return axios.get(`${config.endpoints.base_url}v4/devices/${deviceId}/preview`);
}

export const unregisterDevice = (pairingCode, onSuccess = () => {}, onError = () => {}) => {
  return (dispatch, getState) => {
    return axios.post(`${config.endpoints.base_url}v4/devices/${pairingCode}/unregister`);
  }
}

export const configAppDeviceRequest = (deviceId, usecases) => {
  return axios.post(`${config.endpoints.base_url}v4/devices/${deviceId}/config`, usecases);
}

export const installAppToADeviceRequest = (deviceId, usecase) => {
  return axios.post(`${config.endpoints.base_url}v4/devices/${deviceId}/install`, usecase);
}

export const uninstallAppToADeviceRequest = (deviceId, usecase) => {
  return axios.post(`${config.endpoints.base_url}v4/devices/${deviceId}/uninstall`, usecase);
}

export const getDeviceAppActionsByDeviceIDRequest = (deviceId, usecases) => {
  return axios(`${config.endpoints.base_url}v4/devices/${deviceId}/app-actions`);
}

export const cancelAppInstallationToADeviceRequest = (deviceId, usecase) => {
  return axios.post(`${config.endpoints.base_url}v4/devices/${deviceId}/cancel`, usecase);
}

export const updateAppToADeviceRequest = (deviceId, usecase) => {
  return axios.post(`${config.endpoints.base_url}v4/devices/${deviceId}/update`, usecase);
}

export const addDevicesToSite = (devices = [], siteId, zoneId) => {

  const mappedDevices = devices.map((device) => {

    const deviceFeeders = device.feeders.map(feeder => {
      return {
        id: feeder.id,
        location_id: zoneId
      }
    });

    const mappedTags = device.tags.map(tag => tag.id);

    return {
      id: device.id,
      name: device.name,
      site_id: siteId,
      location_id: zoneId,
      description: device.description ? device.description : '',
      type_id: device.type_id,
      tags: mappedTags,
      feeders: deviceFeeders
    }
  });

  const mappedDevicesRequests = mappedDevices.map(device => {

    const { id, ...deviceBody } = device;

    return axios.put(
      `${config.endpoints.base_url}v2/devices/${id}`,
      deviceBody
    );
  })

  return Promise.all(mappedDevicesRequests);
}

export const deviceSendAction = (id, data, onSuccess = () => { }, onError = () => { }) => {
  return (dispatch, getState) => {
    axios.post(
      `${config.endpoints.base_url}v3/devices/${id}/send-actions`,
      data
    ).then((resp) => {
      return onSuccess(resp.data);
    }).catch((err) => {
      return onError(err);
    });
  };
};

export const getDeviceActions = (id, onSuccess = () => { }, onError = () => { }) => {
  return (dispatch, getState) => {
    axios.get(
      `${config.endpoints.base_url}v3/devices/${id}/actions?limit=20`
    ).then((resp) => {
      return onSuccess(resp.data);
    }).catch((err) => {
      return onError(err);
    });
  };
};

export const bulkDevicesAssignServiceApplets = (devices) => {
  return axios.post(
    `${config.endpoints.base_url}v4/devices/bulk/apps/assign`, devices
  );
};

export const bulkDevicesAssignSitesAndLocations = (devices) => {
  return axios.post(
    `${config.endpoints.base_url}v4/devices/bulk/configs/sites`, devices
  );
};

export const bulkDevicesAssignServiceAppletsAndSitesAndLocations = (bulkDevicesAssignServiceAppletsAndAssignSitesAndLocationsPayload) => {

  // /v4/devices/bulk/site-apps/install
  // [
  //     {
  //         "device_id": 1896,
  //         "apps": ["am","am-nano"],
  //         "site": {
  //             "site_id": 906,
  //             "location_id": 905
  //         }
  //     },
  //     {
  //         "device_id": 1896,
  //         "apps": ["am"],
  //         "site": {
  //             "site_id": 906,
  //             "location_id": 905
  //         }
  //     }
  // ]



  // return axios.post(
  //   `${config.endpoints.base_url}v4/devices/bulk/site-apps/install`, devices
  // );
  console.log(bulkDevicesAssignServiceAppletsAndAssignSitesAndLocationsPayload);
}

export const getDeviceSensors = (id, data) => {
  return axios.get(`${config.endpoints.base_url}v4/devices/${id}/sensors?data=${decodeURIComponent(JSON.stringify(data))}&action=sensor_get`)
};

export const testConnectionDeviceSensor = (id, data) => {
  return axios.post(`${config.endpoints.base_url}v4/feeders/devices/${id}/test-connection`, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
};

export const getDeviceSensorPreview = (id, data) => {
  return axios.post(`${config.endpoints.base_url}v4/devices/${id}/sensors/preview`, {
    session_token: data.session_token,
    sensor_path: data.sensor_path
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
};


export const getDeviceSensorPreviewRTSP = (id, data) => {
  return axios.post(`${config.endpoints.base_url}v4/devices/${id}/sensors/preview`, {
    session_token: data.session_token,
    data,
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
};

export const getOngoingInstallations = () => {
  // return Promise.resolve({
  //   "data": {
  //     "status": true,
  //     "message": "Success",
  //     "data": [
  //       {
  //         "date_created": "2026-01-19T07:57:38.048Z",
  //         "name": "DESKTOP-D34CQTF",
  //         "app_code": "am",
  //         "icon_link": "https://storage.googleapis.com/bkt-viana-dev-assets/development/asset-serviceapplets/viana-service-applets-am.png?alt=media&access_token=ya29.dr.ARQiAB-bk9LLak7VTgQpxZdqITLa6-P6QVv8hZl_FtG9Q4m9Hbl7mQaZACzT7KXOnHS4iaprfwXPA1qRXsDgX4YGeVB5X26Ecr3xfD7rbTtgbiKez-23K_B-9SSzRG4E3ZVgo4Axbf3JimxGVBkmmHrVtmij0ouoMcRo3gczVcoo4cyGb6Q3njaZMg-RYMHAm7b0RakfW_PX2CcSF1v-gMbFV-xnGibmA1qwBC01quHwdWlnRfzZhOx81lKUrpi_NlSsyn15uQpByo8ANFpWZvW6eOB1L3ecy5G3qZUPiaD3rFgOsXtvIpKuRtGjtqI5njtP28NrGgwYvP7lsv_sS2Gj8pX60nsgeu-vlQ6W0SZoi_K_lExu_DlKLt0Z_5Mqlr3rmBjooCSPVv8eptW94dkTraTxLUI59t2-_KW8fiufipy7pdRbQC0sx9Md6HfOO8gnTnCbRSRzJlUmo92eq4szZJFkdNrX3J1X6qwhaDHoKcDOAG2ik4pdtDLkt9aVApG4a0EYcGw0jglbaqpRsiuvFNLxxh7MioFyX0FGDK7TNqCIhbdb57u3bVaQ0qqUfSxD5eaOflRjtEHCjOABr3cEIZ-plzX4ad63bQ364VbRzbhEOQLmekBsL3_o5vXk8LSyQvqvMCT8VQwZ1unyL9XnCIJIkvMHTr572r_HJkJzTcvpNX-agF6C01OQ2V7sHeGNt8g8FsWi_QmAdJoHnMcotrEr9Yvacgqt2vHYsNR2dPzDp1Tn9ZqvzuQv7dC7Eohb0UA50hEA5RD7YqG0mEGBhFhQNXeQlm9fQryllzA3stiI3XbeYn5V26QCBub-ua0t6SS6dmpwjPdWogH9T4R1sZre83e2MxqHIi9roefHscm8U0o3b6ixGmR8baTDmb4Z7bVrME3ITSDHf4S8k7rPPUPBlCbHUCQiD4gIeo3sMc5NffmsPQwVMQCYv5N-E0tQoGd60cxgA30g3qv9_tYqUpkV2vzq7XHNiOZmFH37cmQK4yHRqI8v1pxJPsda0BIhC8XqWnzA_Ut9cY_zAlS3GegD6U4ilTSPgd3S-HC_WihTIex7H6CVs_TrK2hW9IVfeo_4tXl8WjKl1m-RUtxMYp7QAeRTCw9PjQ75BdzD6f2zpJEsssC3-HDTgUj53giFmVYYc5B88PeA4Bu31bIU8N6JIbDQ-JPg1wJAY5n4XG1uFg15dRaB5DtkEOmBMvM8ysXP94e4PnsWtip1XBg_gfI0ntWhtk7oegtdAYSEy4jFStcdu6bfMTQgpCckKLRWxG89yzEqWImP2z2WdNPYJf-q4KbAMtafGV34UGJfLEy3AT1q1cPuJcmXkkp3dL0CDPT_6ER_or4nM0c_stOqNDdSK98KFiMNG8aEg8dle7QsV_vWsEZKMFtMpMQgwFOv7gKCVdLSqSkPfYwzfp8GMyq3q0cTzB6AXEpgZRa_zRLHEOEgqFal18bVXksMKoeAKqOPCW2SVPrb9BBcVB4nZU45peTZgBEgG4v2F3Bio5U9mTBAiyb98Oe-hWkCzWMTdZiYryB3B-GWyOF49uUzIbKS2lKuZgtEshHWH2EWe1yph8a6oR30lCfi5GY",
  //         "description": "Install am version 2.3.0-alpha.1 service applet to device DESKTOP-D34CQTF",
  //         "app_version": "2.3.0-alpha.1",
  //         "status": "processing",
  //         "device_id": 1941,
  //         "action": "install",
  //         "progress": "12.469147786947062 out of 100",
  //         "batch_token": null
  //       }
  //     ]
  //   },
  //   "status": 200,
  //   "statusText": "OK",
  //   "headers": {},
  //   "config": {}
  // });
  return axios.get(`${config.endpoints.base_url}v4/devices/service-applets/processing`);
}

export const getDeviceAvailableApps = (id) => {
  return axios.get(`${config.endpoints.base_url}v4/devices/${id}/available-apps`)
};
